export default __webpack_public_path__ + "732900be7850970f0316d03cc55201da.svg";